<template lang="html">

    <b-modal v-model="showAddAdvertiser" :title="title" @hide="$emit('update:is-show', false)">
        <div>
            <form @submit.prevent='saveAdvertiser'>
                <div>
                    Search By Offer ID:<br />
                    <input @keyup="getOfferDetailsByID" type="text" v-model.trim="offerId" class="def input-c-141 modal_input input-offerId">
                    <div v-if="offerName !== ''">
                        Offer Name: {{ offerName }}
                    </div>
                    <hr />
                </div>
                <div>
                    Advertiser:<br />
                    <b-form-select @change="getGlobalOfferByAdvId(advertiserForm.adv_id)" v-model="advertiserForm.adv_id" :options="advRows"></b-form-select>
                    <hr />
                </div>
                <div v-if="advertiserForm.adv_id !== 0 ">
                    Global Offer:<br />
                   <input type="text" v-model.trim="selectedOffer" @keyup="autoc" @focus="autoc" class="def input-c-141 modal_input input-select">
                    <div class="autoc" v-if="show_autoc">
                        <div v-for="row in autoc_res" :key="row">
                            <div @click="autoc_select" class="autoc_item">
                                {{ row }}
                            </div>
                        </div>
                    </div>
                    <hr />
                </div>


            </form>
        </div>
        <template #modal-footer="{ ok, cancel, hide }">
            <b-button :disabled="!((advertiserForm.adv_id !== 0 && selectedOffer.length !== 0) || offerName.length !== 0)" size="sm" variant="success" @click.prevent="submit">
                OK
            </b-button>
        </template>
    </b-modal>
</template>
<script>
export default {

    props: ['isShow', 'shouldUpdate', 'isVtaRoute', 'placement'],
    data() {
        return {
            advertiserForm: {
                adv_id: 0,
                global_offer_id: 0,
            },
            offerId: '',
            offerName: '',
            selectedOffer: '',
            submmited: false,
            globalOfferRows: [],
            advRows: [],
            title: 'Assoc Global Offer to Ad Set',
            autoc_res: [],
            show_autoc: false,
            newGlobalOfferIdMin: 40000,
        }
    },
    async created() {
        await this.getData()
    },
    computed: {
        showAddAdvertiser: {
            get: function() {
                return this.isShow
            },
            set: function() {

            }
        }
    },
    methods: {
        isNewGlobalOfferId(id) {
            return Number(id) >= this.newGlobalOfferIdMin
        },
        rowLabel(offerObj) {
            if (this.isNewGlobalOfferId(offerObj.id)) {
                return `${offerObj.id} - ${offerObj.name}`
            }
            return offerObj.name
        },
        resolveAssocOfferId() {
            const typedId = String(this.offerId || '').trim()
            if (/^\d+$/.test(typedId) && this.isNewGlobalOfferId(typedId)) {
                return Number(typedId)
            }

            const selected = String(this.selectedOffer || '').trim()
            const newHit = this.globalOfferRows.find((r) => r.isNew && (r.label === selected || String(r.value) === selected))
            if (newHit) {
                return Number(newHit.value)
            }

            const legacyHit = this.globalOfferRows.find((r) => !r.isNew && r.text === selected)
            if (legacyHit) {
                return Number(legacyHit.value)
            }

            if (/^\d+$/.test(typedId)) {
                return Number(typedId)
            }
            if (this.advertiserForm.global_offer_id) {
                return Number(this.advertiserForm.global_offer_id)
            }
            return 0
        },
        async getData() {
            const data = await this.$http.post(this.resources.Management.getAdvertisersList)

            if (data.body.res === 'OK') {

                let res = await data.body.data
                this.advRows = res.map(advObj => {
                    return {
                        value: advObj.id,
                        text: advObj.adv_company_name
                    }
                })
            }
        },
        async getGlobalOfferByAdvId(advId) {
            const data = await this.$http.post(this.resources.Management.getGlobalOffersByAdvertise(advId, this.isVtaRoute))
            if (data.body.res === 'OK') {
                if (data.body.data !== null) {
                    let res = await data.body.data
                    this.globalOfferRows = res.map(offerObj => {
                        const isNew = this.isNewGlobalOfferId(offerObj.id)
                        return {
                            value: offerObj.id,
                            text: offerObj.name,
                            label: this.rowLabel(offerObj),
                            isNew,
                        }
                    })
                } else {
                    this.globalOfferRows = []
                }
            }
        },
        async getOfferDetailsByID(e) {
            if (e && e.preventDefault) e.preventDefault()
            const rawId = String(this.offerId || '').trim()
            if (!rawId) {
                this.notifyError(`Please enter offer ID`)
                return
            }
            if (!/^\d+$/.test(rawId)) {
                return
            }
            // Lookup on Enter, or once the id looks complete (>= 3 digits).
            if (e && e.key !== 'Enter' && rawId.length < 3) {
                return
            }
            try {
                let res = await this.$http.get(this.resources.GlobalOffers.fetchGlobalOfferById(rawId))
                let data = await res.json()
                if (data.res !== 'OK' || !data.data || data.data.affiseID === 0) {
                    this.notifyError(`Offer ${rawId} does not exist.`)
                    this.offerId = ''
                    return
                }

                let offerData = data.data
                if (!offerData.is_global_offer) {
                    this.notifyError(`Offer ${offerData.name} is not global.`)
                    this.offerId = ''
                    return
                }

                if (offerData.advertiser_id === 0) {
                    this.notifyError(`Offer ${offerData.name} has no related advertiser.`)
                    this.offerId = ''
                    return
                }
                this.offerName = offerData.name
                this.advertiserForm.adv_id = offerData.advertiser_id
                this.advertiserForm.global_offer_id = Number(rawId)
                await this.getGlobalOfferByAdvId(this.advertiserForm.adv_id)
                this.selectedOffer = this.isNewGlobalOfferId(rawId)
                    ? `${rawId} - ${offerData.name}`
                    : offerData.name
            } catch (err) {
                this.notifyError(err)
            }
        },
        async submit() {
            const globalOfferId = this.resolveAssocOfferId()
            if (!globalOfferId || this.advertiserForm.adv_id === 0) {
                this.notifyError('Please select advertiser and global offer . ')
                return
            }
            this.advertiserForm.global_offer_id = globalOfferId

            const typedId = String(this.offerId || '').trim()
            if (!this.isNewGlobalOfferId(globalOfferId) && !typedId) {
                const inList = this.globalOfferRows.some((r) => !r.isNew && Number(r.value) === globalOfferId)
                if (!inList) {
                    this.notifyError('Please select global offer from the list. ')
                    return
                }
            }
            if (this.advertiserForm.global_offer_id === undefined || this.advertiserForm.global_offer_id === 0) {
                this.notifyError('An error occured ! ')
                return
            }
            try {
                // Get global offer data to compare placement geo to offer geo
                const res = await this.$http.get(this.resources.GlobalOffers.fetchGlobalOfferById(this.advertiserForm.global_offer_id))
                const oData = (res && res.body) || (await res.json())
                if (!oData || oData.res !== 'OK' || !oData.data) {
                    this.notifyError((oData && oData.data) ? String(oData.data) : `Offer ${this.advertiserForm.global_offer_id} could not be loaded.`)
                    return
                }
                const offer = oData.data || {};
                let offerGeo;
                const geoRaw = offer.geo == null ? '' : String(offer.geo)
                if (geoRaw.length === 0) {
                    offerGeo = []
                } else {
                    offerGeo = geoRaw.split(',').map((g) => g.trim()).filter(Boolean)
                }

                const placement = this.placement || {}
                const placementGeo = Array.isArray(placement.geo)
                    ? placement.geo
                    : String(placement.geo || '').split(',').map((g) => g.trim()).filter(Boolean)
                const isGeoMatch = await this.compare(placementGeo, offerGeo)
                if (!isGeoMatch) {
                    this.notifyError(
                        `Please make sure location targeting is the same for the global offer and the adset and try again. (offer: ${offerGeo.join(',') || '—'}, adset: ${placementGeo.join(',') || '—'})`
                    );
                    return;
                }

                const data = await this.$http.post(
                    this.resources.Management.assocGlobalOfferToAdSet(
                        this.advertiserForm.global_offer_id,
                        this.$route.params.placementId
                    )
                )
                if (data.body.res === 'OK') {
                    if (data.body.data !== 0 ) {
                        this.$emit('shouldUpdate');
                        this.notifySuccess('Global offer has successfully created on ad set .')
                    }
                    await this.setDefault();
                    this.$emit('update:is-show', false)
                } else {
                    const detail = data.body && data.body.data
                    this.notifyError(detail ? String(detail) : 'An error occured ! ')
                }
            } catch (err) {
                console.log(err);
                const detail =
                    (err && err.body && err.body.data) ||
                    (err && err.bodyText) ||
                    (err && err.message)
                this.notifyError(detail ? String(detail) : 'An error occured ! ')

            }
        },
        autoc: async function(e) {
            if (this.globalOfferRows.length === 0) {
                return
            }
            this.autoc_res = []
            const needle = (e && e.target && e.target.value != null) ? e.target.value : this.selectedOffer
            const needleLower = String(needle || '').toLowerCase()
            for (let k in this.globalOfferRows) {
                const row = this.globalOfferRows[k]
                if (row.isNew) {
                    if (String(row.value).startsWith(needle) || row.label.toLowerCase().startsWith(needleLower)) {
                        this.autoc_res.push(row.label)
                    }
                } else if (row.text.startsWith(needle)) {
                    this.autoc_res.push(row.label)
                }
            }
            if (this.autoc_res.length > 0) {
                this.show_autoc = true
            } else {
                this.show_autoc = false
            }
        },
        autoc_select: function(e) {
            this.show_autoc = false
            this.selectedOffer = e.target.innerHTML.trim()
            const hit = this.globalOfferRows.find((r) => r.label === this.selectedOffer)
            if (hit) {
                this.advertiserForm.global_offer_id = hit.value
                if (hit.isNew) {
                    this.offerId = String(hit.value)
                }
            }
        },
        async compare(array1, array2) {
            const norm = (arr) => (arr || []).map((g) => String(g || '').trim().toUpperCase()).filter(Boolean).sort()
            const a = norm(array1)
            const b = norm(array2)
            if (a.length != b.length) {
                return false;
            }
            for (var i = 0; i < a.length; i++) {
                if (a[i] != b[i]) {
                    return false;
                }
            }
            return true;
        },
        async setDefault() {
            this.advertiserForm.adv_id = 0;
            this.advertiserForm.global_offer_id = 0;
            this.offerId = '';
            this.offerName = '';
            this.selectedOffer = '';
        }
    },
}
</script>
<style scoped>
.autoc {
    top: 30px;
    left: 270px;
    background-color: white;
    cursor: pointer;
    padding: 5px;
    border: 1px solid gray;
    max-height: 200px;
    overflow-y: auto;
}

.autoc_item {
    padding: 2px;
}

.autoc_item:hover {
    background-color: blue;
    color: white;
}

.input-select {
    width: 100%;
    height: calc(2.0625rem + 2px);
    padding: 0.375rem 1.75rem 0.375rem 0.75rem;
    line-height: 1.5;
    color: #3e515b;
    vertical-align: middle;
    background: #fff url("data:image/svg+xml;charset=utf8,%3Csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 4 5'%3E%3Cpath fill='%2329363d' d='M2 0L0 2h4zm0 5L0 3h4z'/%3E%3C/svg%3E") no-repeat right 0.75rem center;
    background-size: 8px 10px;
    border: 1px solid #c2cfd6;
    border-radius: 0;
    -webkit-appearance: none;
    -moz-appearance: none;
    appearance: none;
}

.input-offerId {
    width: 100%;
    height: calc(2.0625rem + 2px);
    padding: 0.375rem 1.75rem 0.375rem 0.75rem;
    line-height: 1.5;
    color: #3e515b;
    vertical-align: middle;
    border: 1px solid #c2cfd6;
    border-radius: 0;
    -webkit-appearance: none;
    -moz-appearance: none;
    appearance: none;
}
</style>
